import { ApiError } from "@lumora/bridge";
import { ShowingSlot, UsPhone } from "../models/ShowingSlot.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Guest or associate "request a showing" flow for one listing. */
export class ShowingRequestViewModel extends ViewModel {
    client;
    siteSlug;
    listingId;
    options;
    constructor(client, siteSlug, listingId, options = {}) {
        super({
            slots: [],
            selectedSlotId: "",
            phone: "",
            message: "",
            loading: true,
            submitting: false,
            submitted: false,
            error: "",
            success: "",
        });
        this.client = client;
        this.siteSlug = siteSlug;
        this.listingId = listingId;
        this.options = options;
    }
    selectSlot(selectedSlotId) {
        this.setState({ selectedSlotId, submitted: false });
    }
    setPhone(phone) {
        this.setState({ phone, submitted: false });
    }
    setMessage(message) {
        this.setState({ message });
    }
    async loadAvailability() {
        this.setState({ loading: true, error: "" });
        try {
            const instants = await this.client.appointmentAvailability(this.siteSlug);
            this.setState({ slots: ShowingSlot.fromInstants(instants), loading: false });
        }
        catch {
            const fallback = this.options.fallbackSlots;
            if (fallback) {
                this.setState({
                    slots: fallback(),
                    loading: false,
                    error: "Showing mocked availability because scheduling API is not available.",
                });
            }
            else {
                this.setState({
                    slots: [],
                    loading: false,
                    error: "Scheduling availability is not available yet.",
                });
            }
        }
    }
    async submit() {
        this.setState({ success: "", error: "" });
        const slot = this.state.slots.find((s) => s.id === this.state.selectedSlotId);
        if (!slot) {
            this.setState({ error: "Choose an available appointment card first." });
            return false;
        }
        const phone = this.state.phone.trim();
        if (!phone) {
            this.setState({ error: "Phone number is required." });
            return false;
        }
        if (!UsPhone.isValid(phone)) {
            this.setState({ error: "Enter a valid US phone number, like (507) 555-1234." });
            return false;
        }
        this.setState({ submitting: true });
        try {
            await this.client.createAppointment(this.siteSlug, {
                listingId: this.listingId,
                customerName: "Guest",
                phone,
                startsAt: slot.start,
                notes: this.state.message.trim(),
            });
            this.setState({
                submitting: false,
                submitted: true,
                success: this.options.mode === "associate-schedule"
                    ? "Appointment created."
                    : "Request sent. We will contact you to confirm.",
            });
            return true;
        }
        catch (err) {
            const status = err instanceof ApiError ? err.status : 0;
            const error = status === 409
                ? "That slot was just taken. Refresh availability and choose another time."
                : status === 403
                    ? "You do not have permission to schedule this appointment."
                    : "Scheduling backend is not available. No appointment was created.";
            this.setState({ submitting: false, error });
            return false;
        }
    }
}
//# sourceMappingURL=ShowingRequestViewModel.js.map